// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vpc[data-v-4f90e460],.vpc-subnet[data-v-4f90e460]{display:flex;line-height:30px}.vpc-subnet .vpc-name[data-v-4f90e460],.vpc .vpc-name[data-v-4f90e460]{font-weight:700;flex:1}.vpc-subnet .vpc-info[data-v-4f90e460],.vpc .vpc-info[data-v-4f90e460]{font-size:12px;opacity:.7}.vpc-subnet .vpc-name[data-v-4f90e460]{font-weight:400;padding-left:15px}", ""]);
// Exports
module.exports = exports;
